// tslint:disable

import axios from 'axios';
import { Map } from 'immutable';
import { get } from 'lodash';
import * as React from 'react';
import { Environment } from '../../environment/environment';
import { Notification } from '../../index';
import { ListLib } from './list.lib';

export class ListResourceLoader extends React.Component<any, any> {
    public list: ListLib = new ListLib();

    public state: any = {
        isInitialized: false,
        response: null,
        fetchedData: [],
        paginationQuery: Map({limit: 50, page: 1}).asMutable(),
        searchQuery: Map({}).asMutable(),
        viewValue: 0,
    };

    async componentWillMount() {
        if (!this.props.entity) {
            throw new Error(`Unknown entity: ${this.props.entity}`);
        }
    }

    async componentDidMount() {
        this.list.onTriggerFetch$.subscribe(() => {
            this.doQuery();
            // this.fetchList(this.state.searchQuery.toJS());
        })

        this.list.pagination.onPaginate$.subscribe(async (e: any) => {
            if (e.source === 'pagination') {
                if (e.page !== undefined) {
                    this.state.paginationQuery.set('page', e.page);
                }
                if (e.limit !== undefined) {
                    this.state.paginationQuery.set('limit', parseInt(e.limit));
                }
                this.doQuery();
            }
        });

        this.list.console.onQuery$.debounceTime(400).subscribe(async (e: any) => {
            this.state.searchQuery = Map(e);
            this.doQuery();
        });


        this.doQuery();
    }

    public async doQuery() {
        let newQuery = {};

        Object.assign(newQuery, this.state.searchQuery.toJS());
        Object.assign(newQuery, this.state.paginationQuery.toJS());
        Object.assign(newQuery, this.props.forceQuery || {});
        await this.fetchList(newQuery);
    }

    public async fetchList(query: any = {}) {
        this.list.isLoading$.next(true);

        try {
            const response = await axios.get(`${Environment.get('api.base')}/${this.props.entity}`, {
                params: query,
                withCredentials: true
            });

            if (!response.data) {
                this.list.isLoading$.next(false);
                throw new Error('no.data');
            }

            this.setState({
                isInitialized: true,
                fetchedData: get(response, 'data[hydra:member]')
            });
            this.list.setMember(get(response, 'data[hydra:member]'));
            this.list.isLoading$.next(false);

            this.list.pagination.onPaginate$.next({
                source: 'loader',
                limit: query.limit,
                page: query.page,
                total: get(response, 'data[hydra:totalItems]') || 0,
            });

        } catch (err) {
            if (err && err.response && err.response.status === 401) {
                Notification.errorExec("Unauthorized!")
            } else {
                try {
                    Notification.errorExec(get(err, 'response.data[hydra:description]'))
                }
                catch (e) {
                    Notification.errorExec('General error: ' + e.message)
                }
            }
        } finally {
            this.setState({
                viewValue: ++this.state.viewValue
            });
        }

    }

    render() {
        return (this.state.isInitialized && this.state.fetchedData && this.props.render && this.props.render(this.list)) || <i className="fa fa-spin fa-2x fa-circle-o-notch"/>;
    }
}



// WEBPACK FOOTER //
// ./src/components/libs/list-resource-loader.tsx